import styled from 'styled-components';
import { Grid, TextField, Typography } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.main};
  margin-top: -10px;
  padding: 0 0 45px;
  font-size: 1.75rem;
`;

export const SearchBar = styled(TextField)`
  margin-bottom: 15px;
  .MuiOutlinedInput-root {
    border-radius: 30px;
    .MuiOutlinedInput-input {
      padding: 10px 14px;
    }
  }
`;

export const AppArea = styled(Grid)`
  max-height: 74vh;
  overflow: scroll;
  overflow-x: hidden;
  margin-left: 0;
  margin-top:20px;
  ::-webkit-scrollbar {
    width: 5px;
  }
  ::-webkit-scrollbar-track {
    background: #ccc;
  }
  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.palette.primary.main};
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${({ theme }) => theme.palette.primary.variant};
  }
`;

export const Item = styled.div`
  background-color: #e9e9e9;
  border-radius: 15px;
  text-align: center;
  color: ${({ theme }) => theme.palette.secondary.main};
  padding: 5px 10px 15px;
  height: 120px;
  cursor: pointer;
  justify-content: center;
  display: flex;
  flex-direction: column;
  &:hover {
    color: ${({ theme }) => theme.palette.primary.main};
    transition: 0.4s;
  }
`;

export const AppType = styled(Typography)`
  text-align: right;
  font-size: 0.75rem;
`;

export const AppIcon = styled.i`
  font-size: 3rem;
  padding: 10px 0;
`;

export const AppName = styled(Typography)`
  font-size: 0.85rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
`;

export const NoAppArea = styled(Grid)`
  display: flex;
  justify-content: ${({ selected }) => (selected ? '' : 'center')};
  flex-direction: column;
  align-content: ${({ selected }) => (selected ? '' : 'center')};
  padding: 0 50px !important;
  min-height: 740px;
  background: rgb(255 255 255 / 80%);
`;

export const NoAppTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
`;

export const NoAppDesc = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.main};
  font-weight: 600;
`;

export const ImgArea = styled.div`
  text-align: center;
  margin: 30px 0;
  img {
    width: 80%;
  }
`;

export const AppTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: 40px;
`;

export const AppHint = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.main};
  font-weight: 600;
  margin-top: 10px;
`;

export const AppDesc = styled(Typography)`
  color: ${({ theme }) => theme.palette.secondary.main};
  margin: 25px 0;
`;
